import './styles.css';
import { initAuth, login, requireClinicSession } from './auth';
import { hasAuthorizationError } from './auth-callback';
import { renderLanding } from './landing';
import { renderApp } from './app';

const root = document.getElementById('root');
if (!root) {
  throw new Error('#root missing');
}

if (location.pathname.startsWith('/app')) {
  if (hasAuthorizationError(location.search, location.hash)) {
    root.innerHTML = `
      <main class="workspace" role="alert" aria-live="assertive">
        <section class="card">
          <p class="kicker">Acceso profesional</p>
          <h1>No se pudo completar el inicio de sesión</h1>
          <p>La respuesta de autenticación fue rechazada. Intenta de nuevo; si vuelve a ocurrir, contacta al administrador de tu clínica.</p>
          <button class="btn primary" id="retry-login" type="button">Intentar de nuevo</button>
          <a class="quiet-link" href="/">Volver a Génesis</a>
        </section>
      </main>`;
    root.querySelector('#retry-login')?.addEventListener('click', () => void login('/app'));
  } else {
    const ok = await requireClinicSession();
    if (!ok) {
      root.innerHTML = '<p class="boot">Redirigiendo a la cuenta de la clínica…</p>';
    } else {
      await renderApp(root);
    }
  }
} else {
  await renderLanding(root);
  void initAuth().then(() => renderLanding(root));
}
